export const COLUMNS = [
    {
        Header: "Name",
        Footer: "Name",
        accessor: "name",
    },
    {
        Header: "Code",
        Footer: "Code",
        accessor: "code",
    },
    {
        Header: "Status",
        Footer: "Status",
        accessor: "status",
    },
    
    {
        Header: "Is Test",
        Footer: "Is Test",
        accessor: "isTest",
    },
    {
        Header: "Is Sponsor Limit Checked",
        Footer: "Is Sponsor Limit Checked",
        accessor: "isSponsorLimitChecked",
    },
    {
        Header: "Action",
        Footer: "Action",
        accessor: "action",
    },
];
